import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IReqBodyCargarArchivo, IResCargaCalificaciones, IResObtenerArchivoLog, IResObtenerListaArchivos } from 'src/app/interfaces/carga-calificaciones';
import { ArchivoEjemploCargaCalificaciones } from 'src/app/interfaces/utils';
import { CargaCalificacionesService } from 'src/app/services/carga-calificaciones/carga-calificaciones.service';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-view-configuracion-carga-calificaciones',
  templateUrl: './view-configuracion-carga-calificaciones.component.html',
  styleUrls: ['./view-configuracion-carga-calificaciones.component.scss']
})
export class ViewConfiguracionCargaCalificacionesComponent {
  dtOptions: DataTables.Settings = { ...DatatableConfig.dtSortWithoutSearch_2 }
  renderTable: boolean = false

  filtrosCargados: any = {}
  tieneErrores: any = {}
  submitted: boolean = false

  rolDaraCentral: boolean = false
  listaArchivos: any = []

  parametrosForm = this.formBuilder.group({
    archivo: ['', [Validators.required]],
  })

  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  alertaExitosa = ''

  archivoEjemplo : ArchivoEjemploCargaCalificaciones = new ArchivoEjemploCargaCalificaciones();
  nombreEjemplo: string = "ejemplo_carga_calificaciones.xlsx"
  filesAttached: any = []
  archivoBase64: any = ''
  allowedFilesExt = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ]
  cabeceraBase64 = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
  allowedFileSizeBytes = 1048576
  textoCargaArchivo = "Seleccionar archivo..."
  error = ""
  nombreUsuario: string = "";

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private _cargaCalificaciones: CargaCalificacionesService,
    private _perfilamientoService: PerfilamientoService
  ) {
    this.obtenerListaArchivos()
  }

  ngOnInit():void {
    let datosUsuario = this._perfilamientoService.getUsuario()
    this.nombreUsuario =datosUsuario.username
    
    interval(60000).subscribe(() => {
      this.obtenerListaArchivos()
    })
  }

  obtenerListaArchivos(): void {
    this.renderTable = false
    this._cargaCalificaciones.getListaArchivos().subscribe(
      (res: IResObtenerListaArchivos) => {
        this.listaArchivos = res.archivos
        this.renderTable = true
      }, ():void => {
        this.listaArchivos = []
        this.renderTable = true
      }
    )
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  descargarEjemplo(): void {
    const bstr = atob(this.archivoEjemplo.archivo);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], this.nombreEjemplo, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    let link = document.createElement('a');

    //Adicionar y descargar el archivo
    link.href = window.URL.createObjectURL(file);
    link.download = this.nombreEjemplo;
    link.click();
  }

  limpiarCargaArchivo():void {
    this.textoCargaArchivo = "Seleccionar archivo..."
    this.filesAttached = []
    this.submitted = false
  }

  saveFile ( base64: string | null, nombreArchivo: string | null, ext: string ) {
    const mediaType=`data:application/${ext};base64,`
    const file = base64
    let a = document.createElement('a')
    a.href = mediaType+file
    a.download = nombreArchivo+'.'+ext
    a.click()
  }

  obtenerLog(archivoId: number): void {
    this._cargaCalificaciones.getArchivoLog(archivoId).subscribe(
      (res: IResObtenerArchivoLog) => {
        if ( res.error === null ) {
          this.saveFile(res.archivo, res.nombreArchivo, res.extension)
        } else {
          this.mostrarInfoModal('Atención', res.error?.mensaje ?? 'Hubo un error en los servicios')
        }
      }
    )
  }

  resetearValidacion(tipo: string = 'default') {
    this.submitted = false
    this.tieneErrores["archivo"] = false
  }

  limpiarMensajes() {
    setTimeout(() => {
      this.error = ''
    }, 4000)
  }

  _handleReaderLoaded(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.archivoBase64 = btoa(binaryString);
  }

  onFileChanged(event: any, index: number) {
    const file:File = event.target.files[0];
    if ( file ) {
      if ( this.filesAttached[index] ) this.filesAttached[index] = null

      if ( ((file.size)) > this.allowedFileSizeBytes ) {
        this.error = 'El tamaño del archivo es mayor a 1Mb.'
        this.limpiarMensajes()
        return
      }
      if ( !this.allowedFilesExt.includes(file.type) ) {
        this.error = 'Tipo de archivo no válido. El tipo de archivo debe ser xlsx'
        this.limpiarMensajes()
        return
      }
      this.filesAttached[index] = {};
      this.filesAttached[index].archivo = file;
      this.filesAttached[index].nombreArchivo = file.name;
      this.filesAttached[index].tipoArchivo = file.type;

      let reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(event);
      reader.readAsBinaryString(file);
      this.textoCargaArchivo = file.name;

      event.target.value = "";
    }
  }

  mostrarAlertaExito(texto: string) {
    this.alertaExitosa = texto
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setTimeout(() => {
      this.alertaExitosa = ''
    }, 3000);
  }

  procesar():void {
    this.submitted = true
    if ( this.filesAttached.length === 0 ) {
      this.tieneErrores['archivo'] = true
      return
    }
    let reader = new FileReader()
    reader.onload = (readerEvt: any) => {
      let binaryString = readerEvt.target.result
      this.archivoBase64 = binaryString.split("base64,")[1]
      const reqBody: IReqBodyCargarArchivo = {
        archivo: this.archivoBase64,
        nombreArchivo: this.filesAttached[0].nombreArchivo,
        extension: 'xlsx',
        usuarioCreacion: this.nombreUsuario
      }
      this._cargaCalificaciones.postCargarArchivo(reqBody).subscribe(
        (res: IResCargaCalificaciones) => {
          if ( res.error === null ) {
            setTimeout(() => {
              this.resetearValidacion()
              this.limpiarMensajes()
              this.limpiarCargaArchivo()
              this.obtenerListaArchivos()
              this.mostrarAlertaExito('El archivo ha sido cargado exitosamente')
            }, 500);
            
          } else {
            this.mostrarInfoModal('Atención', res?.error?.mensaje ?? 'Hubo un error en los servicios')
          }
        }
      )
    }
    reader.readAsDataURL(this.filesAttached[0].archivo)
  }
}
